import PropsType from 'prop-types';
import { Button, Image, Modal, ModalBody } from 'react-bootstrap';
import thumb from '../../assets/images/thumb.svg';
import ButtonIcon from '../../assets/images/ViewButton.svg';

const InterstitialThankPopUp = ({ handleClose, Apply, interstitialShow }) => {
    
  return (
    <>
      <Modal show={interstitialShow} size="sm" centered animation={true}>
        <ModalBody className="p-4">
          <div className="d-flex justify-content-center pb-3">
            <Image src={thumb} alt="thumnail" className="cursor-pointer" width={70} height={70} />
          </div>
          <h6 className="p-2 fs-14 font-semi-bold mx-2">
            Thank you for sharing your information. A representative from {Apply?.bankName} will reach out to assist you
            with opening your CD.
          </h6>
          <div className='open-now-wrapper'>
            <div className="d-flex justify-content-center">
              <Button
                variant="light"
                className="d-flex text-center arrow mt-2 fs-14 font-semi-bold explore apply option arrow"
                onClick={handleClose}
              >
                Explore More Rates
                <div className="d-flex justify-content-center">
                  <Image className="buttonArrow" src={ButtonIcon} alt="Button" width={30} height={20} />
                </div>
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

InterstitialThankPopUp.propTypes = {
  Apply: PropsType.object,
  handleClose: PropsType.func,
  interstitialShow: PropsType.bool,
};
export default InterstitialThankPopUp;
